import './registerServiceWorker'
import './configureCompat'
import { createApp } from 'vue'
import pinia from '@/stores/pinia'

// Imports plugins
import EventBusPlugin from '@nicolaudie-group/ng-ui-kit/plugins/EventBusPlugin'
// Import styles
import '@nicolaudie-group/ng-ui-kit/styles/main.scss'
import '@nicolaudie-group/ng-ui-kit/styles/icon.css'
// Helpers import
import { configure as configureStorage } from '@nicolaudie-group/ng-ui-kit/helpers/storage'
import buildMode from '@nicolaudie-group/ng-ui-kit/helpers/buildMode'

// Must be called before calling "useRouterStore"
import router from '@/router/index'
import ready from '@/hooks/ready'

import App from './App.vue'

configureStorage('pb-')

/**
 * Create the app
 */
const app = createApp(App)

if (buildMode.dev) {
  app.config.performance = true
}

/**
 * Initialize plugins
 */
app.use(pinia)
app.use(router)
app.use(EventBusPlugin)
app.use(ready)

/**
 * Mount app
 */
app.mount('#app')
